import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  label: {
    // Set defaults
    display: 'flex',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal'
  },
  title: {
    composes: '$label',
    fontSize: 40,
    fontWeight: 300,
    textAlign: 'left',
    color: theme.colors.page__subtitle,
    [`@media (max-width: ${theme.screens.mobile}px)`]: {
      fontSize: 32
    }
  },
  titleSecondary: {
    composes: '$title',
    color: theme.colors.text_secondary
  },
  titleLight: {
    fontSize: 40,
    composes: '$title',
    color: theme.colorPalette.white,
    fontWeight: 200
  },
  subtitle: {
    composes: '$label',
    fontSize: 24,
    lineHeight: 1.2,
    fontWeight: 400,
    color: theme.colors.page__subtitle
  },
  subtitle1: {
    composes: '$label',
    fontSize: '24px',
    lineHeight: 1.2,
    fontWeight: 400,
    color: theme.colors.page__subtitle1
  },
  subtitle1Regular: {
    composes: '$label',
    fontSize: '24px',
    lineHeight: 1.33,
    fontWeight: 400,
    color: theme.colorPalette.green_75
  },
  subtitleSmall: {
    composes: '$label',
    fontSize: '20px',
    lineHeight: 1.2,
    fontWeight: 400,
    color: theme.colors.page__subtitle1
  },
  subtitleLight: {
    composes: '$label',
    fontSize: 24,
    lineHeight: 1.2,
    fontWeight: 300,
    color: theme.colorPalette.white
  },
  smallSubtitleLight: {
    composes: '$label',
    fontSize: 16,
    lineHeight: 1.2,
    fontWeight: 300,
    color: theme.colorPalette.white
  },
  formTitle: {
    composes: '$label',
    fontSize: 24,
    lineHeight: 1.2,
    fontWeight: 300,
    color: theme.colors.text_secondary
  },
  formSubTitle: {
    composes: '$label',
    fontSize: 16,
    color: theme.colors.light_text
  },
  coverageSubtitle: {
    composes: '$label',
    fontSize: 16,
    lineHeight: 1.5,
    color: theme.colors.medium_text
  },
  sectionSubtitle: {
    composes: '$label',
    fontSize: 16,
    lineHeight: 1.5,
    color: theme.colorPalette.green_90
  },
  formSubTitleLight: {
    composes: '$label',
    fontSize: 16,
    color: theme.colors.info__label_title
  },
  infoLabel: {
    composes: '$label',
    lineHeight: 1.4,
    fontSize: 10,
    color: theme.colors.info__label_secondary,
    textTransform: 'uppercase',
    fontWeight: 600
  },
  infoLabelWhite: {
    composes: '$label',
    lineHeight: 1.4,
    fontSize: 10,
    color: theme.colorPalette.beige_60,
    textTransform: 'uppercase',
    fontWeight: 600
  },
  infoValue: {
    composes: '$label',
    lineHeight: 1.25,
    fontSize: 16,
    color: theme.colors.info__label_primary
  },
  infoValueBold: {
    composes: '$infoValue',
    fontWeight: 600
  },
  infoValueFormatted: {
    composes: '$infoValue',
    'white-space': 'pre-line'
  },
  infoSubtitle: {
    composes: '$label',
    lineHeight: 1.2,
    fontSize: 20,
    color: theme.colors.page__subtitle
  },
  infoSubtitleSmall: {
    composes: '$label',
    lineHeight: 1.5,
    fontSize: 16,
    color: theme.colors.page__subtitle1
  },
  infoSubtitleSmallLight: {
    composes: '$label',
    lineHeight: '20px',
    fontSize: 14,
    color: theme.colorPalette.green_75
  },
  infoTitle: {
    composes: '$label',
    lineHeight: 1.2,
    fontSize: 20,
    color: theme.colorPalette.green_75
  },
  infoTitleSmall: {
    composes: '$label',
    lineHeight: 1.5,
    fontSize: 16,
    color: theme.colorPalette.green_75
  },
  infoSubtitleWhite: {
    composes: '$label',
    lineHeight: 1.2,
    fontSize: 20,
    color: theme.colorPalette.white
  },
  infoSubtitleOrange: {
    composes: '$infoSubtitle',
    color: theme.colorPalette.orange_50
  },
  infoSubtitleBold: {
    composes: '$infoSubtitle',
    fontWeight: 500,
    display: 'contents'
  },
  infoInnerTitle: {
    composes: '$label',
    fontSize: 20,
    display: 'inline-flex',
    lineHeight: 1.2,
    color: theme.colors.info__label_title
  },
  infoInnerTitleBold: {
    composes: '$label',
    fontSize: 16,
    display: 'inline-flex',
    lineHeight: 1.2,
    color: theme.colors.info__label_title,
    fontWeight: 600
  },
  infoCardTitle: {
    composes: '$label',
    display: 'inline',
    fontSize: 14,
    lineHeight: 1,
    color: theme.colors.info__label_tertiary,
    fontWeight: 600
  },
  infoCardText: {
    composes: '$label',
    display: 'inline',
    fontSize: 12,
    lineHeight: 1.25,
    color: theme.colors.info__label_text,
    fontWeight: 600
  },
  coverageLabel: {
    composes: '$label',
    lineHeight: 1.4,
    fontSize: 10,
    color: theme.colors.coverage__label_secondary,
    fontWeight: 500,
    textTransform: 'uppercase'
  },
  coverageLabelDark: {
    composes: '$label',
    lineHeight: 1.4,
    fontSize: 10,
    color: theme.colorPalette.green_75,
    fontWeight: 500,
    textTransform: 'uppercase'
  },
  coverageValue: {
    composes: '$label',
    lineHeight: 1.25,
    fontSize: 16,
    color: theme.colors.coverage__label_primary
  },
  coverageParagraph: {
    composes: '$label',
    fontWeight: 300,
    display: 'block',
    fontSize: 14,
    color: theme.colors.coverage__label_paragraph
  },
  coverageAmount: {
    composes: '$label',
    fontWeight: 'normal',
    display: 'inline-flex',
    fontSize: 24,
    color: theme.colors.coverage__label_primary,
    paddingRight: 8
  },
  action: {
    fontSize: 16,
    fontWeight: 600,
    cursor: 'pointer',
    color: theme.colorPalette.orange_50
  },
  toast: {
    fontSize: 14,
    color: theme.colorPalette.beige_50
  },
  greenSmall: {
    composes: '$label',
    fontSize: 16,
    lineHeight: 1,
    color: theme.colorPalette.green_75
  },
  greenExtraSmall: {
    composes: '$label',
    display: 'inline',
    fontSize: 14,
    lineHeight: 1,
    color: theme.colorPalette.green_75,
    fontWeight: 500
  },
  darkGreenSmall: {
    composes: '$greenSmall',
    color: theme.colorPalette.green_90
  },
  darkGreenSmallBold: {
    composes: '$greenSmall',
    color: theme.colorPalette.green_90,
    fontWeight: 600,
    lineHeight: 1.5
  },
  greenBig: {
    composes: '$label',
    fontWeight: 300,
    fontSize: 40,
    lineHeight: 1,
    color: theme.colorPalette.green_75
  },
  darkGreenMedium: {
    composes: '$label',
    display: 'inline',
    fontSize: 20,
    lineHeight: 1.2,
    color: theme.colorPalette.green_90
  },
  darkGreenBig: {
    composes: '$label',
    fontSize: 20,
    display: 'inline-flex',
    lineHeight: 1.2,
    color: theme.colorPalette.green_90
  },
  whiteSmall: {
    composes: '$label',
    fontSize: 12,
    lineHeight: 1,
    color: theme.colorPalette.white
  },
  whiteMedium: {
    composes: '$label',
    fontSize: 20,
    lineHeight: 1,
    fontWeight: 500,
    color: theme.colorPalette.white
  },
  darkSmall: {
    composes: '$label',
    display: 'inline',
    fontSize: 14,
    lineHeight: 1,
    color: theme.colorPalette.green_90,
    fontWeight: 500
  },
  darkestSmallest: {
    composes: '$label',
    display: 'inline',
    fontSize: 14,
    lineHeight: 1.5,
    color: theme.colorPalette.green_100,
    fontWeight: 500
  },
  smallDarkGreenBold: {
    composes: '$label',
    display: 'inline',
    fontSize: 12,
    lineHeight: 1.33,
    color: theme.colorPalette.green_100,
    fontWeight: 400
  },
  notificationText: {
    composes: '$label',
    display: 'inline',
    fontSize: 12,
    lineHeight: 1.5,
    color: theme.colorPalette.green_100,
    fontWeight: 400
  },
  noteSmall: {
    fontSize: 10,
    fontWeight: 300,
    lineHeight: 1.4,
    color: theme.colorPalette.beige_50
  },
  paymentLabel: {
    composes: '$label',
    fontWeight: 300,
    fontSize: 10,
    color: theme.colorPalette.white
  },
  policyLabel: {
    composes: '$label',
    fontWeight: 500,
    fontSize: 12,
    color: theme.colorPalette.beige_50
  },
  titleDollarLabel: {
    composes: '$label',
    textAlign: 'right',
    color: theme.colorPalette.white,
    fontSize: 16
  },
  formLabel: {
    composes: '$label',
    fontWeight: 500,
    fontSize: 9,
    color: theme.colorPalette.beige_50_op_75,
    textTransform: 'uppercase',
    lineHeight: 1
  },
  formLabelLight: {
    composes: '$label',
    fontWeight: 500,
    fontSize: 9,
    color: theme.colorPalette.green_75,
    textTransform: 'uppercase',
    lineHeight: 1,
    paddingBottom: 5
  },
  smallLightLabel: {
    composes: '$label',
    fontWeight: 400,
    fontSize: 14,
    color: theme.colorPalette.white,
    opacity: 0.2,
    marginLeft: 44,
    marginTop: -36
  },
  status: {
    composes: '$label',
    textTransform: 'uppercase',
    fontSize: 10,
    fontWeight: 600
  },
  statusUnknown: {
    composes: '$status',
    color: theme.colors.gray_03
  },
  statusUnknownMedium: { composes: '$statusUnknown', fontSize: 14 },
  statusClosed: {
    composes: '$status',
    color: theme.colorPalette.green_90
  },
  statusClosedMedium: { composes: '$statusClosed', fontSize: 14 },
  statusOpen: {
    composes: '$status',
    color: theme.colorPalette.green_legacy_86c440
  },
  statusOpenMedium: { composes: '$statusOpen', fontSize: 14 },
  statusWarning: {
    composes: '$status',
    color: theme.colorPalette.orange_75
  },
  statusWarningMedium: { composes: '$statusWarning', fontSize: 14 },
  smallWarning: {
    composes: '$label',
    fontWeight: 'normal',
    fontSize: 10,
    color: theme.colors.error,
    lineHeight: 1.2
  },
  largeWarning: {
    composes: '$label',
    fontWeight: 'bold',
    fontSize: 14,
    color: theme.colors.error,
    lineHeight: 1.2,
    textAlign: 'center',
    textTransform: 'uppercase'
  },
  discount: {
    fontWeight: 'normal',
    fontSize: 16,
    color: theme.colorPalette.beige_50,
    lineHeight: 1
  },
  discountPromo: {
    composes: '$label',
    fontSize: 16,
    lineHeight: 1.2,
    fontWeight: 600,
    color: theme.colorPalette.white
  },
  smallWhiteBold: {
    composes: '$label',
    color: theme.colorPalette.white,
    fontSize: 14,
    fontWeight: 600
  },
  smallWhite: {
    composes: '$label',
    color: theme.colorPalette.white,
    fontSize: 14
  },
  modalBody: {
    color: theme.colorPalette.green_80,
    fontSize: 14,
    lineHeight: '20px'
  },
  // NOTE: Below this comment are the styles matching the styleguide in Zeplin, so we can add them progressively.
  h1: {
    composes: '$label',
    fontSize: 40,
    color: theme.colorPalette.green_75,
    fontWeight: 300,
    lineHeight: 1.4
  },
  body1: {
    composes: '$label',
    color: theme.colors.text_primary,
    fontSize: 16,
    lineHeight: 1.5
  },
  body1Bold: {
    composes: '$body1',
    fontWeight: 600
  },
  body2: {
    composes: '$label',
    color: theme.colors.text_primary,
    fontSize: 14,
    lineHeight: 1.4
  },
  body2Bold: {
    composes: '$body2',
    fontWeight: 600
  },
  body3: {
    composes: '$label',
    color: theme.colors.text_primary,
    fontSize: 12,
    lineHeight: 1.33
  },
  body3Italic: {
    composes: '$body3',
    display: 'inline',
    color: theme.colorPalette.green_75,
    fontStyle: 'italic'
  },
  body3ItalicSemibold: {
    composes: '$body3Italic',
    fontWeight: 600
  },
  green75small: {
    composes: '$label',
    color: theme.colorPalette.green_75,
    fontSize: 12,
    lineHeight: 1.33
  },
  green75Big: {
    composes: '$label',
    color: theme.colorPalette.green_75,
    fontWeight: 300,
    fontSize: 40,
    lineHeight: 1
  },
  green15smallBold: {
    composes: '$label',
    color: theme.colorPalette.green_80,
    fontSize: 12,
    fontWeight: 600,
    lineHeight: 1.33
  },
  green15BigBold: {
    composes: '$label',
    color: theme.colorPalette.green_80,
    fontSize: 20,
    fontWeight: 600,
    lineHeight: 1.2
  },
  body3Bold: {
    composes: '$body3',
    fontWeight: 600
  },
  body4: {
    fontSize: 10,
    fontWeight: 600,
    color: theme.colorPalette.green_75,
    lineHeight: 1.2
  },
  toolDescription: {
    composes: '$label',
    fontSize: 14,
    color: theme.colorPalette.beige_50,
    lineHeight: 1.5,
    marginTop: (props) => (props.hasError ? 0 : -10),
    marginBottom: 5,
    whiteSpace: 'pre'
  },
  liveTaskMessage: {
    composes: '$label',
    border: `1px solid ${theme.colorPalette.green_75_op_60}`,
    padding: theme.spacing(2, 4),
    borderRadius: 5
  },
  formFieldDescription: {
    composes: '$label',
    fontSize: 12,
    color: theme.colorPalette.white,
    marginTop: -25
  },
  italicLight: {
    composes: '$label',
    fontSize: 16,
    fontStyle: 'italic',
    color: theme.colorPalette.beige_75
  },
  italicLightSmall: {
    composes: '$italicLight',
    fontSize: 12
  },
  italicDark: {
    composes: '$italicLight',
    color: theme.colorPalette.green_80
  }
});

export default makeStyles(styles);
